export const repositoryMatchesFullSlug = (
  repository: BB.Repository,
  workspace: BB.Workspace,
  fullSlug: string
) => {
  // We support slugs or UUIDs in our URLs, for either workspace or repository
  const validFullSlugs = [
    `${workspace.slug}/${repository.slug}`,
    `${workspace.slug}/${repository.uuid}`,
    `${workspace.uuid}/${repository.uuid}`,
    `${workspace.uuid}/${repository.slug}`,
    `{}/${repository.uuid}`,
  ];

  // Slugs are case insensitive. We use localeCompare to handle case
  // insensitivity as well as accented characters. (Done also in
  // `./src/sections/repository/repository-route.tsx`)
  return validFullSlugs.some(
    validSlug =>
      validSlug.localeCompare(fullSlug, undefined, {
        sensitivity: 'base',
      }) === 0
  );
};
